import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate } from "react-router-dom";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

const Page404 = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <SoftBox
                pt={6}
                pb={6}
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
              >
                <SoftTypography variant="h1" fontWeight="bold" color="error" gutterBottom>
                  404
                </SoftTypography>
                <SoftTypography variant="h4" fontWeight="medium" gutterBottom>
                  {/* Page Not Found */}
                  {t("lang.not_found")}
                </SoftTypography>
                <SoftTypography variant="body1" mb={4}>
                  {/* {`Sorry, the page you're looking for doesn't exist.`} */}
                  {t("lang.not_found_text")}
                </SoftTypography>
                <SoftBox display="flex" gap={2} justifyContent="center">
                  <SoftButton variant="gradient" color="info" onClick={handleGoBack}>
                    {/* Go Back */}
                    {t("lang.actions.go_back")}
                  </SoftButton>
                  <SoftButton variant="outlined" color="dark" onClick={handleGoHome}>
                    {/* Go to Home */}
                    {t("lang.actions.go_home")}
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </Card>
          </Grid>
        </Grid>
      </SoftBox>
    </DashboardLayout>
  );
};

export default Page404;
